import React, {useEffect, useState} from 'react';
import useBooksStore from "../../store/bookListStore";
import {useParams, useSearchParams} from "react-router-dom";
import {serialize} from "v8";
import './Pagination.css';


interface PaginationProps {
    totalCount:number
}

const Pagination = (props:PaginationProps) => {

    const [searchParams,setSearchParams] = useSearchParams();

    //const {totalCount} = useBooksStore(state => state);
    const [offset,setOffset] = useState(Number(searchParams?.get('offset')) ?? 0);
    const [limit, setLimit] = useState(Number(searchParams?.get('limit')) ?? 5);

    const [pageAmount,setPageAmount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const [elems, setElems] = useState<number[]>([])


    useEffect(()=>{
        /*if(searchParams.has('limit'))
            setLimit(searchParams?.get('limit') as unknown as number);
        if(searchParams.has('offset'))
            setOffset(searchParams?.get('offset') as unknown as number);
        */
    },[]);

    useEffect(()=>{
        const safeLimit = limit > 0 ? limit : 5;
        setPageAmount(Math.ceil(props.totalCount / safeLimit));
        setCurrentPage(1);
        setOffset(0);
    },[props.totalCount, limit])

    const SetPage = (page:number) => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      setCurrentPage(page);
      setOffset((page-1) * limit);
      let value = ((page - 1) * limit) as unknown as string;
      setSearchParams((prev => {
          prev.set('offset',value);
          return prev;
      }));
    }

    useEffect(()=>{
        const safeLimit = limit > 0 ? limit : 5;
        setPageAmount(Math.ceil(props.totalCount / safeLimit));
    },[props.totalCount,limit]);

    useEffect(()=>{
        const items:number[] = [];
        const windowSize = 5;
        let start = Math.max(1, currentPage - 2);
        let end = start + windowSize - 1;
        if (end > pageAmount) {
            end = pageAmount;
            start = Math.max(1, end - windowSize + 1);
        }
        for(let i = start; i <= end; i++) {
            items.push(i);
        }
        setElems(items);
    },[pageAmount,currentPage])

    useEffect(()=>{
        const newLimit = searchParams.has('limit') ? Number(searchParams.get('limit')) : 5;
        setLimit(newLimit > 0 ? newLimit : 5);
        setOffset(searchParams.has('offset') ? Number(searchParams.get('offset')) : 0);
    },[searchParams])

    return (
        <div>
            <nav className='w-100 Pagination' aria-label="Page navigation example">

                <ul className="pagination">
                    <li className="page-item">
                        <a className="page-link" onClick={()=>SetPage(1)} aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    {elems.map((number) =>
                        <li key={`page-item-${number}`} className={`page-item ${number === currentPage ? 'active' : ''}`}><a className="page-link" onClick={()=>SetPage(number)}>{number}</a></li>
                    )}
                    <li className="page-item">
                        <a className="page-link" onClick={()=>SetPage(pageAmount)} aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
                <div className={"mt-1"}>
                    Всего страниц {pageAmount}
                </div>
                
            </nav>
        </div>
    );
};

export default Pagination;